"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLowerCase = void 0;
function getLowerCase(value) {
    if (value) {
        return value.toLowerCase();
    }
    return value;
}
exports.getLowerCase = getLowerCase;
//# sourceMappingURL=utils.js.map